import { ComponentProps } from "react";
import { ContentCard } from "./ContentCard";
import { HorizontalCard } from "./scaffolds/HorizontalCard";
import { VerticalHalfCard } from "./scaffolds/VerticalHalfCard";
import { css } from "@emotion/react";

const desktopStyle = css`
  display: flex;

  @media (max-width: 768px) {
    display: none;
  }
`;

const mobileStyle = css`
  display: none;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const CurationContentCard = ({
  device,
  ...props
}: Omit<ComponentProps<typeof ContentCard>, "type">) => {
  const map = {
    "web+tablet": <VerticalHalfCard {...props} />,
    app: <HorizontalCard {...props} />,
  };

  return device ? (
    map[device]
  ) : (
    <>
      <VerticalHalfCard css={desktopStyle} {...props} />
      <HorizontalCard css={mobileStyle} {...props} />
    </>
  );
};
